import { SnapshotComparisonFilters, TriStateFilter } from './types';

export const CENTER = 'cder';

export const DEFAULT_PAGE_SIZE = 20;

export const PAGE_SIZE_OPTIONS = [10, 20, 40, 60];

export const DEFAULT_FILTERS: SnapshotComparisonFilters = {
  applicationNumber: '',
  qcStatus: 'all',
  changeDetectionStatus: 'all'
};

export const QC_STATUS_FILTER_OPTIONS: { label: string; value: TriStateFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'QCed', value: 'true' },
  { label: 'Not QCed', value: 'false' }
];

export const CHANGE_DETECTION_FILTER_OPTIONS: { label: string; value: TriStateFilter }[] = [
  { label: 'All', value: 'all' },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' }
];
